import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { UserX, Trash2, Loader2 } from 'lucide-react';

export const DeleteUserDialog = ({ open, onOpenChange, user, deleting, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="bg-slate-800 border-slate-700" data-testid="delete-user-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-white flex items-center gap-2">
          <UserX className="h-5 w-5 text-red-500" />
          Delete User
        </AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">
          Are you sure you want to delete <span className="text-white font-medium">{user?.company_name}</span>?
          <br /><br />
          This will permanently delete:
          <ul className="list-disc list-inside mt-2 text-slate-500">
            <li>The user account ({user?.email})</li>
            <li>All their assessments and reports</li>
            <li>All follow-up notes</li>
          </ul>
          <br />
          <span className="text-red-400 font-medium">This action cannot be undone.</span>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel
          disabled={deleting}
          data-testid="cancel-delete-user-btn"
          className="bg-slate-700 text-white border-slate-600 hover:bg-slate-600"
        >
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          disabled={deleting}
          data-testid="confirm-delete-user-btn"
          className="bg-red-500 hover:bg-red-600 text-white"
        >
          {deleting ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Deleting...
            </>
          ) : (
            <>
              <Trash2 className="h-4 w-4 mr-2" />
              Delete User
            </>
          )}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
